// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h6[data-v-693d6994]{font-weight:700;font-style:italic;text-align:center;color:#c82333}", ""]);
// Exports
module.exports = exports;
